import { isCounter, isJobId, isRecord, isVersion } from './generationValidation';
import { DELETION_PHASES, DELETION_STATUSES, DeletionJob, PROTECTION_REASONS, VersionState, VERSION_STATES } from './versionTypes';

export function isUtcTime(value: unknown): value is string {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) return false;
  const milliseconds = Date.parse(value);
  if (!Number.isFinite(milliseconds)) return false;
  const canonical = new Date(milliseconds).toISOString();
  return canonical === value;
}
export function isVersionState(value: unknown): value is VersionState {
  if (!isRecord(value) || !isVersion(value.version)) return false;
  const hasState = VERSION_STATES.some((state) => state === value.state);
  const hasFlags = typeof value.is_current === 'boolean' && typeof value.retention_eligible === 'boolean' && typeof value.deletion_enabled === 'boolean';
  const hasProtection = value.protection_reason === null || PROTECTION_REASONS.some((reason) => reason === value.protection_reason);
  const retirement = value.retirement;
  const hasRetirement = retirement === null || (isRecord(retirement) && isVersion(retirement.replacement_version) && (retirement.retired_not_before === null || isUtcTime(retirement.retired_not_before)));
  return hasState && hasFlags && hasProtection && hasRetirement && isCounter(value.retention_seconds);
}
export function isDeletionJob(value: unknown): value is DeletionJob {
  if (!isRecord(value)) return false;
  const hasIdentity = isJobId(value.id) && isVersion(value.version);
  const hasStatus = DELETION_STATUSES.some((status) => status === value.status);
  const hasPhase = DELETION_PHASES.some((phase) => phase === value.phase);
  const hasError = value.error_code === null || value.error_code === 'deletion_failed' || value.error_code === 'deletion_uncertain';
  return hasIdentity && hasStatus && hasPhase && hasError && isCounter(value.completed) && isCounter(value.batches) && isUtcTime(value.created_at) && isUtcTime(value.updated_at);
}
export function invalidVersionData(): never {
  throw new Error('Не удалось подтвердить состояние версии. Обновите данные; если запрос удаления уже отправлен, не создавайте новый.');
}
